
  // Test on: https://cards-dev.twitter.com/validator
  // Test on: https://developers.facebook.com/tools/debug/
  export default {
    props: {
      type: {
        type: String,
        default: 'activities'
      },
    },

  }
  